import classNames from "classnames";
import React from "react";

export default function ImageSetGrid({className, children}: {
    className?: string,
    children: React.ReactNode
}) {
    return (
        <div className={classNames("grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-5 gap-y-11", className)}>
            {children}
        </div>
    )
}